import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import Utils from "../../../../../../utils/Utils";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json"

class Anamnesi extends Component {
    state = {
        anamnesi: {
            gravidanza: "",
            settimanaGravidanza: "",
            malattiaEpatica: "",
            immunodepressione: "",
            terapie: "",
            hiv: "",
            asplenia: "",
            diabete: "",
            malnutrizione: "",
            tumore: "",
            trapianto: "",
            annoTrapianto: "",
            altro: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.pulisciValori = this.pulisciValori.bind(this);
    }

    componentDidMount() {
        let newState = this.state.anamnesi;
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.anamnesi) {
            let anamnesiCopia = this.props.segnalazioneCopia.schedaSpeciale.anamnesi;
            newState.gravidanza = anamnesiCopia.gravidanza ? anamnesiCopia.gravidanza : "";
            newState.settimanaGravidanza = anamnesiCopia.settimanaGravidanza ? anamnesiCopia.settimanaGravidanza : "";
            newState.malattiaEpatica = anamnesiCopia.malattiaEpatica ? anamnesiCopia.malattiaEpatica : "";
            newState.immunodepressione = anamnesiCopia.immunodepressione ? anamnesiCopia.immunodepressione : "";
            newState.terapie = anamnesiCopia.terapie ? anamnesiCopia.terapie : "";
            newState.hiv = anamnesiCopia.hiv ? anamnesiCopia.hiv : "";
            newState.asplenia = anamnesiCopia.asplenia ? anamnesiCopia.asplenia : "";
            newState.diabete = anamnesiCopia.diabete ? anamnesiCopia.diabete : "";
            newState.malnutrizione = anamnesiCopia.malnutrizione ? anamnesiCopia.malnutrizione : "";
            newState.tumore = anamnesiCopia.tumore ? anamnesiCopia.tumore : "";
            newState.trapianto = anamnesiCopia.trapianto ? anamnesiCopia.trapianto : "";
            newState.annoTrapianto = anamnesiCopia.annoTrapianto ? anamnesiCopia.annoTrapianto : "";
            newState.altro = anamnesiCopia.altro ? anamnesiCopia.altro : "";

        } else {
            newState.gravidanza = this.props.sesso === "M" ? "02" : "";
        }
        this.setState({anamnesi: newState});
        this.controlloDati();
        let objectForBackend = Object.assign({}, Utils.removeFieldFromObject({...this.state.anamnesi}, "corretto"))
        this.props.setStatePadre(newState, "anamnesi", objectForBackend)
    }


    riceviValoreInput(field, event) {
        let newState = this.state.anamnesi;
        if (field && field.target && field.target.id) {
            newState[field.target.id] = field.target.value;
        } else {
            newState[field] = event.target.value;
        }
        let newStatePulito = this.pulisciValori(newState);
        this.setState({anamnesi: newStatePulito})
        this.controlloDati();
        let objectForBackend = Object.assign({}, Utils.removeFieldFromObject({...this.state.anamnesi}, "corretto"))
        this.props.setStatePadre(newStatePulito, "anamnesi", objectForBackend)
    }

    pulisciValori(state) {
        if ((state.gravidanza && state.gravidanza !== "01") || !state.gravidanza) {
            state.settimanaGravidanza = "";
        }
        if (this.props.sesso && this.props.sesso === "M") {
            state.gravidanza = "02";
        }
        if ((state.immunodepressione && state.immunodepressione !== "01") || !state.immunodepressione) {
            state.terapie = "";
            state.hiv = "";
            state.asplenia = "";
            state.diabete = "";
            state.malnutrizione = "";
            state.tumore = "";
            state.trapianto = "";
            state.annoTrapianto = "";
            state.altro = "";
        }
        if ((state.trapianto && state.trapianto !== "01") || !state.trapianto) {
            state.annoTrapianto = "";
        }
        return state;

    }

    controlloDati() {
        let anamnesi = this.state.anamnesi;
        anamnesi.corretto = [];
        if (!anamnesi.gravidanza) anamnesi.corretto[0] = "Campo \"Gravidanza in corso\" mancante";
        this.setState({anamnesi: anamnesi})

    }

    render() {
        const {t} = this.props
        return (
            <div>
                <div style={{marginTop: "10px"}}/>
                <div><h6>Anamnesi</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div>
                        <div className={"row"}>
                            <div className={"col-lg-12 mt-1"}>
                                <div className={"row"}>
                                    <div className={"col-lg-7"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.Anamnesi.gravidanza")}
                                            <span className={styles.mandatoryColor}>*</span>
                                        </p>
                                        <div className={"row"}>
                                            <div className={"col-lg-1"}>
                                                <RadioButton id={"gravidanzaSi"}
                                                             name={"gravidanza"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                             value={"01"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.gravidanza === "01"}
                                                             disabled={this.props.sesso && this.props.sesso === "M"}
                                                />
                                            </div>
                                            <div className={"col-lg-1"}>
                                                <RadioButton id={"gravidanzaNo"}
                                                             name={"gravidanza"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                             value={"02"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.gravidanza === "02"}
                                                             disabled={this.props.sesso && this.props.sesso === "M"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"gravidanzaNonSo"}
                                                             name={"gravidanza"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                             value={"03"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.gravidanza === "03"}
                                                             disabled={this.props.sesso && this.props.sesso === "M"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.Anamnesi.settimanaGravidanza")}
                                        </p>
                                        <Input
                                            type={"textarea"}
                                            id={"settimanaGravidanza"}
                                            onChange={this.riceviValoreInput}
                                            field={"settimanaGravidanza"}
                                            value={this.state.anamnesi.settimanaGravidanza}
                                            disabled={(!this.state.anamnesi.gravidanza || this.state.anamnesi.gravidanza !== "01") || (this.props.sesso && this.props.sesso === "M")}
                                            placeholder={"Settimana di gestazione"}
                                        />
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-lg-7"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.Anamnesi.malattiaEpatica")}
                                        </p>
                                        <div className={"row"}>
                                            <div className={"col-lg-1"}>
                                                <RadioButton id={"malattiaEpaticaSi"}
                                                             name={"malattiaEpatica"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                             value={"01"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.malattiaEpatica === "01"}
                                                />
                                            </div>
                                            <div className={"col-lg-1"}>
                                                <RadioButton id={"malattiaEpaticaNo"}
                                                             name={"malattiaEpatica"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                             value={"02"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.malattiaEpatica === "02"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"malattiaEpaticaNonSo"}
                                                             name={"malattiaEpatica"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                             value={"03"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.malattiaEpatica === "03"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-lg-7"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.Anamnesi.immunodepressione")}
                                        </p>
                                        <div className={"row"}>
                                            <div className={"col-lg-1"}>
                                                <RadioButton id={"immunodepressioneSi"}
                                                             name={"immunodepressione"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                             value={"01"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.immunodepressione === "01"}
                                                />
                                            </div>
                                            <div className={"col-lg-1"}>
                                                <RadioButton id={"immunodepressioneNo"}
                                                             name={"immunodepressione"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                             value={"02"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.immunodepressione === "02"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"immunodepressioneNonSo"}
                                                             name={"immunodepressione"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                             value={"03"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.immunodepressione === "03"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <fieldset disabled={this.state.anamnesi.immunodepressione !== "01"}>
                                    <div className={"row"}>
                                        <div className={"col-lg-4"}>
                                            <p className={styles.labelHeader}
                                               style={{color: "#1b7ea9", marginTop: "2rem"}}>
                                                {t("SchedaSpecialeEpatiteE.Anamnesi.immunodepressioneSeSi")}
                                            </p>
                                        </div>
                                    </div>
                                    <div style={{marginLeft: "2rem"}}>
                                        <div className={"row"}>
                                            <div className={"col-lg-4"}>
                                                <p className={styles.labelHeader}
                                                   style={{color: "#1b7ea9", marginTop: "10px"}}>
                                                    {t("SchedaSpecialeEpatiteE.Anamnesi.terapie")}
                                                </p>
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"terapieSi"}
                                                             name={"terapie"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                             value={"01"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.terapie === "01"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"terapieNo"}
                                                             name={"terapie"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                             value={"02"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.terapie === "02"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"terapieNonSo"}
                                                             name={"terapie"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                             value={"03"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.terapie === "03"}
                                                />
                                            </div>
                                        </div>


                                        <div className={"row"}>
                                            <div className={"col-lg-4"}>
                                                <p className={styles.labelHeader}
                                                   style={{color: "#1b7ea9", marginTop: "10px"}}>
                                                    {t("SchedaSpecialeEpatiteE.Anamnesi.hiv")}
                                                </p>
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"hivSi"}
                                                             name={"hiv"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                             value={"01"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.hiv === "01"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"hivNo"}
                                                             name={"hiv"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                             value={"02"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.hiv === "02"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"hivNonSo"}
                                                             name={"hiv"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                             value={"03"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.hiv === "03"}
                                                />
                                            </div>
                                        </div>

                                        <div className={"row"}>
                                            <div className={"col-lg-4"}>
                                                <p className={styles.labelHeader}
                                                   style={{color: "#1b7ea9", marginTop: "10px"}}>
                                                    {t("SchedaSpecialeEpatiteE.Anamnesi.asplenia")}
                                                </p>
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"aspleniaSi"}
                                                             name={"asplenia"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                             value={"01"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.asplenia === "01"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"aspleniaNo"}
                                                             name={"asplenia"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                             value={"02"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.asplenia === "02"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"aspleniaNonSo"}
                                                             name={"asplenia"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                             value={"03"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.asplenia === "03"}
                                                />
                                            </div>
                                        </div>

                                        <div className={"row"}>
                                            <div className={"col-lg-4"}>
                                                <p className={styles.labelHeader}
                                                   style={{color: "#1b7ea9", marginTop: "10px"}}>
                                                    {t("SchedaSpecialeEpatiteE.Anamnesi.diabete")}
                                                </p>
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"diabeteSi"}
                                                             name={"diabete"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                             value={"01"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.diabete === "01"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"diabeteNo"}
                                                             name={"diabete"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                             value={"02"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.diabete === "02"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"diabeteNonSo"}
                                                             name={"diabete"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                             value={"03"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.diabete === "03"}
                                                />
                                            </div>
                                        </div>

                                        <div className={"row"}>
                                            <div className={"col-lg-4"}>
                                                <p className={styles.labelHeader}
                                                   style={{color: "#1b7ea9", marginTop: "10px"}}>
                                                    {t("SchedaSpecialeEpatiteE.Anamnesi.malnutrizione")}
                                                </p>
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"malnutrizioneSi"}
                                                             name={"malnutrizione"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                             value={"01"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.malnutrizione === "01"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"malnutrizioneNo"}
                                                             name={"malnutrizione"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                             value={"02"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.malnutrizione === "02"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"malnutrizioneNonSo"}
                                                             name={"malnutrizione"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                             value={"03"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.malnutrizione === "03"}
                                                />
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-lg-4"}>
                                                <p className={styles.labelHeader}
                                                   style={{color: "#1b7ea9", marginTop: "10px"}}>
                                                    {t("SchedaSpecialeEpatiteE.Anamnesi.tumore")}
                                                </p>
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"tumoreSi"}
                                                             name={"tumore"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                             value={"01"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.tumore === "01"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"tumoreNo"}
                                                             name={"tumore"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                             value={"02"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.tumore === "02"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"tumoreNonSo"}
                                                             name={"tumore"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                             value={"03"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.tumore === "03"}
                                                />
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-lg-4"}>
                                                <p className={styles.labelHeader}
                                                   style={{color: "#1b7ea9", marginTop: "10px"}}>
                                                    {t("SchedaSpecialeEpatiteE.Anamnesi.trapianto")}
                                                </p>
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"trapiantoSi"}
                                                             name={"trapianto"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                             value={"01"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.trapianto === "01"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"trapiantoNo"}
                                                             name={"trapianto"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                             value={"02"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.trapianto === "02"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"trapiantoNonSo"}
                                                             name={"trapianto"}
                                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                             value={"03"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.anamnesi.trapianto === "03"}
                                                />
                                            </div>
                                            <div className={"col-lg-1"}>
                                                <p className={styles.labelHeader}
                                                   style={{color: "#1b7ea9", marginTop: "10px"}}>
                                                    {t("SchedaSpecialeEpatiteE.Anamnesi.annoTrapianto")}
                                                </p>
                                            </div>
                                            <div className={`col-lg-1 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                                <Input
                                                    id={"annoTrapianto"}
                                                    min="0"
                                                    onChange={this.riceviValoreInput}
                                                    field={"annoTrapianto"}
                                                    value={this.state.anamnesi.annoTrapianto}
                                                    disabled={!this.state.anamnesi.trapianto || this.state.anamnesi.trapianto !== "01"}
                                                    placeholder={t("Anno")}
                                                />
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-lg-4"}>
                                                <p className={styles.labelHeader}
                                                   style={{color: "#1b7ea9", marginTop: "10px"}}>
                                                    {t("SchedaSpecialeEpatiteE.Anamnesi.altro")}
                                                </p>
                                            </div>
                                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                                <Input
                                                    type={"textarea"}
                                                    id={"altro"}
                                                    onChange={this.riceviValoreInput}
                                                    field={"altro"}
                                                    value={this.state.anamnesi.altro}
                                                    placeholder={t("SchedaSpecialeEpatiteE.Anamnesi.altro")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation('common')(Anamnesi)
